import * as React from 'react';

export type ModalVisible = boolean;

export interface UseModalProps {
  defaultVisible?: ModalVisible;
}

export interface UseModalReturn {
  isModalVisible: boolean;
  setModalVisible: (value: (
    ((prevState: boolean) => boolean) | boolean)
  ) => void;
  showModal?(): void;
  hideModal?(): void;
}

/**
 * The hook create store for the modal
 * @param {UseModalProps} props
 * @return {UseModalReturn}
 * @constructor
 */
export default function UseModal(props?: UseModalProps): UseModalReturn {
  const [
    isModalVisible,
    setModalVisible,
  ] = React.useState<ModalVisible>(props?.defaultVisible || false);

  /**
   * Show the modal
   */
  function showModal(): void {
    setModalVisible(true);
  }

  /**
   * Hide the modal
   */
  function hideModal(): void {
    setModalVisible(false);
  }

  return {
    isModalVisible,
    setModalVisible,
    showModal,
    hideModal,
  };
}
